const mutations = {
  /*
  SET_TREEPOSITION:(state,position)=>{
    state.treePosition = position
  }*/
}

export default mutations
